/* eslint-disable indent */
import React from 'react';
import styled from 'styled-components';

import { MOBILE, TABLET, DESKTOP } from 'helpers/styles/media';

import Form from '../Form/FormBlock';
import { FormWrapperStyles } from '../UI/UI';

const FormSection = () => {
  return (
    <Wrapper>
      <FormWrapper>
        <Form />
      </FormWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  background: #f2f2f2;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0,0,0,.15);
  margin: 0px auto 15px auto;

  @media ${TABLET} {
    margin: 32px 32px 16px;
    padding: 20px;
  }

  @media ${MOBILE} {
    margin: 32px 16px 16px;
    padding: 20px;
  }
`;

const FormWrapper = styled.div`
  @media ${DESKTOP} {
    position: relative;
    top: 10px;
  }

  ${FormWrapperStyles}
`;

export default FormSection;
